import React from "react";
import "./ui-pending.scss";

export type StatTileTone = "success" | "warning" | "danger" | "info";

interface StatTileProps {
  label: React.ReactNode;
  value: React.ReactNode;
  /** Colours the value when it carries a judgement. */
  tone?: StatTileTone;
}

/** KPI tile: uppercase label over a large tabular number (design-system candidate). */
const StatTile: React.FC<StatTileProps> = ({ label, value, tone }) => (
  <div className="tesc-stat">
    <div className="tesc-stat__label">{label}</div>
    <div className={tone ? `tesc-stat__value tesc-stat__value--${tone}` : "tesc-stat__value"}>{value}</div>
  </div>
);

export default StatTile;
